import React from "react";
import PropTypes from "prop-types";
import AttendanceListNew from "../attendanceListNew";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";

const queryClient = new QueryClient();

/**
 * Wrapper para AttendanceListNew que mantiene compatibilidad con la estructura actual
 * Este componente puede reemplazar a attendanceFilterList para usar el nuevo diseño
 */
const AttendanceFilterListNewContainer = (props) => {
  const { t } = useTranslation();

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.session.title"), path: PATHS.LIST_SESSION },
    { label: t("forms.attendance.titleList") },
  ];

  return (
    <>
      {/* <div className="row justify-content-center mt-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.attendance.titleList")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />

      <div className="row justify-content-center"> */}
        <div className="col-12">
          <QueryClientProvider client={queryClient}>
            <AttendanceListNew uuid={props.uuid} session={props.session} />
          </QueryClientProvider>
        </div>
      {/* </div> */}
    </>
  );
};

AttendanceFilterListNewContainer.propTypes = {
  uuid: PropTypes.string.isRequired,
  session: PropTypes.object.isRequired,
};

export default AttendanceFilterListNewContainer;
